import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import {lightColors, darkColors, ysveColors} from '@/config/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    options: { customProperties: true },
    default: 'light',
    dark:localStorage.getItem('theme') === 'dark' || (localStorage.getItem('theme') === 'system' && window.matchMedia('(prefers-color-scheme: dark)').matches) ,
    disable: false,
    themes: {
      dark: darkColors,
      light: lightColors
    },
  },
  breakpoint: {
    thresholds: {
      xs: 340,
      sm: 540,
      md: 820,
      lg: 1280,
    }
  }
})
